import format from 'date-fns/format';
import formatISO from 'date-fns/formatISO';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
import { createLocalizationProvider } from '@atlaskit/locale';

/**
 * Format used by atlaskit datepicker
 */
const DATE_FORMAT = 'yyyy-MM-dd';
/**
 * Format used by atlaskit timepicker
 */
export const TIME_FORMAT = 'HH:mm';

/**
 * Reciving date and time strings using DATE_FORMAT and TIME_FORMAT and returning a single string in ISO format
 * returns empty string if date or time is invalid
 */
export const parseDateTimeToISO = (date: string, time: string): string => {
	const parsedDate = parse(`${date} ${time}`, `${DATE_FORMAT} ${TIME_FORMAT}`, new Date());

	if (!isValid(parsedDate)) {
		return '';
	}

	return formatISO(parsedDate);
};

/**
 * Parse date ISO string to DATE_FORMAT
 * returns empty string date is invalid
 */
export const parseDateValue = (date: string): string => {
	if (!isValid(parseISO(date))) {
		return '';
	}

	return format(new Date(date), DATE_FORMAT);
};

/**
 * Parse date ISO string to TIME_FORMAT
 * returns empty string date is invalid
 */
export const parseTimeValue = (date: string): string => {
	if (!isValid(parseISO(date))) {
		return '';
	}

	return format(new Date(date), TIME_FORMAT);
};

export const getTimePlaceholder = (time: string, locale: string): string => {
	const { formatTime } = createLocalizationProvider(locale);
	const parsedDate = parse(time, `${TIME_FORMAT}`, new Date());

	if (!isValid(parsedDate)) {
		return time;
	}

	return formatTime(parsedDate);
};
